const MODULE_NAME = 'hirekMorzsamenu';
class HirekMorzsamenuController {
	constructor($scope) {
		'ngInject';
		$scope.$on('hirekMorzsamenuChange', (e, value)=>{
			this.hirCim = value;
		});
	}
}

export default angular.module(MODULE_NAME, [])
	.controller('hirekMorzsamenuController', HirekMorzsamenuController).name;



// WEBPACK FOOTER //
// ./source/applications/hirek/hirek-reszletes/hirek-morzsamenu.js